import type { paths } from '@luxuryescapes/contract-svc-content';

export type TermsAndConditionsBrand =
  paths['/api/content/terms-and-conditions/{brand}']['get']['parameters']['path']['brand'];

/** svc-content's brand list, which differs from `~/consts/brands`. */
export const TERMS_AND_CONDITIONS_BRANDS: Array<{ value: TermsAndConditionsBrand; label: string }> = [
  { value: 'luxuryescapes', label: 'Luxury Escapes' },
  { value: 'lebusinesstraveller', label: 'LE Business Traveller' },
  { value: 'leagenthub', label: 'LE Agent Hub' },
  { value: 'scoopontravel', label: 'Scoopon' },
  { value: 'cudotravel', label: 'Cudo' },
  { value: 'dealstravel', label: 'Deals' },
  { value: 'treatmetravel', label: 'Treat Me' },
  { value: 'kogantravel', label: 'Kogan Travel' },
  { value: 'affiliatesite', label: 'Affiliate Site' },
];

export const DEFAULT_TERMS_AND_CONDITIONS_BRAND: TermsAndConditionsBrand = 'luxuryescapes';

/**
 * The brands that can be edited today. Add to this as other brands take content on.
 * Note that only luxuryescapes can be selected for editing using this UI at this point in time.
 */
export const TERMS_AND_CONDITIONS_SELECTABLE_BRANDS: ReadonlySet<TermsAndConditionsBrand> = new Set([
  DEFAULT_TERMS_AND_CONDITIONS_BRAND,
]);

export const termsAndConditionsBrandLabel = (brand: string): string =>
  TERMS_AND_CONDITIONS_BRANDS.find((option) => option.value === brand)?.label ?? brand;

export const DEFAULT_TERMS_AND_CONDITIONS_LOCALE = 'en-AU';

export const TERMS_AND_CONDITIONS_LOCALES: Array<{ value: string; label: string }> = [
  { value: DEFAULT_TERMS_AND_CONDITIONS_LOCALE, label: 'English (en-AU)' },
  { value: 'fr-FR', label: 'French (fr-FR)' },
  { value: 'de-DE', label: 'German (de-DE)' },
  { value: 'ar-SA', label: 'Arabic (ar-SA)' },
];

const RTL_TERMS_AND_CONDITIONS_LOCALES = new Set(['ar-SA']);

export const isRtlTermsAndConditionsLocale = (locale: string): boolean => RTL_TERMS_AND_CONDITIONS_LOCALES.has(locale);

export const TERMS_AND_CONDITIONS_SLUG_PATTERN = /^[a-z0-9]+(-[a-z0-9]+)*$/;

export const TERMS_AND_CONDITIONS_SLUG_MAX_LENGTH = 255;
